(function () {
	const ALL_WORD_RE = /\bAll\b/i;

	function markLinksWithWordAll(root) {
		if (!root) return;
		root.querySelectorAll('a[href]').forEach((a) => {
			if (a.closest('.social-links')) return;
			const t = a.textContent.replace(/\s+/g, ' ').trim();
			if (!ALL_WORD_RE.test(t)) return;
			a.classList.add('menu-drawer__link--all-word');
		});
	}

	function runMarkAllWordLinks() {
		markLinksWithWordAll(document.getElementById('menu-drawer-desktop'));
		markLinksWithWordAll(document.getElementById('mobile-menu'));
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', runMarkAllWordLinks);
	} else {
		runMarkAllWordLinks();
	}

	const drawer = document.getElementById('menu-drawer-desktop');
	if (!drawer) return;

	/* Keep in sync with header-custom.css (.header-menu-desktop hidden / .header-menu-mobile shown). */
	const mqMobile = window.matchMedia('(max-width: 992px)');
	const mqReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	const header = document.querySelector('.header-custom');
	const mobileMenuBtn = document.querySelector('.header-menu-mobile button');
	const announcement = document.querySelector('.thb-global-notification');
	const wrapper = document.querySelector('#wrapper');
	const backdrop = header?.querySelector('.menu-drawer__backdrop');
	const tabs = drawer.querySelectorAll('.menu-drawer__tab');
	const panels = drawer.querySelectorAll('.menu-drawer__panel');
	const navItems = document.querySelectorAll('.top-level-menu-item');
	const secondaryDrawer = drawer.querySelector('.menu-drawer__secondary');
	const closeDuration = getComputedStyle(drawer).getPropertyValue('--menu-drawer-motion-duration-close').trim();

	let resizeTimer;
	let previousBodyOverflow = '';
	let isScrollLocked = false;
	let previousFocusedEl = null;
	let isClosingDrawer = false;
	let closeDrawerTransitionHandler = null;
	let secondaryTapShieldTimer = null;

	function setDrawerTop() {
		const announcementPx = announcement ? announcement.offsetHeight : 0;
		const headerPx = mqMobile.matches && header ? header.offsetHeight : 0;
		const px = announcementPx + headerPx;
		drawer.style.top = px + 'px';
		document.documentElement.style.setProperty('--menu-drawer-top', px + 'px');
		document.documentElement.style.setProperty('--announcement-bar-height', announcementPx + 'px');
		if (header) header.style.marginTop = '0px';
	}

	function syncMobileMenuButton() {
		if (!mobileMenuBtn || !mqMobile.matches) return;
		const open = drawer.classList.contains('is-open');
		const menuIcon = mobileMenuBtn.querySelector('.js-nav-mobile-menu-icon');
		const closeIcon = mobileMenuBtn.querySelector('.js-nav-mobile-close-icon');
		if (menuIcon) menuIcon.toggleAttribute('hidden', open);
		if (closeIcon) closeIcon.toggleAttribute('hidden', !open);
		mobileMenuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
	}

	function lockScroll() {
		if (!wrapper || isScrollLocked) return;
		previousBodyOverflow = document.body.style.overflow;
		previousFocusedEl = document.activeElement;
		document.body.style.overflow = 'hidden';
		document.documentElement.style.overflow = 'hidden';
		wrapper.classList.add('menu-drawer-open');
		document.body.classList.add('menu-drawer-open');
		document.documentElement.classList.add('menu-drawer-open');
		isScrollLocked = true;
	}

	function unlockScroll() {
		if (!wrapper || !isScrollLocked) return;
		document.body.style.overflow = previousBodyOverflow || '';
		document.documentElement.style.overflow = '';
		wrapper.classList.remove('menu-drawer-open');
		document.body.classList.remove('menu-drawer-open');
		if (backdrop) {
			backdrop.style.removeProperty('opacity');
			backdrop.style.removeProperty('transition-duration');
		}
		document.documentElement.classList.remove('menu-drawer-open');
		isScrollLocked = false;
		previousBodyOverflow = '';
		if (previousFocusedEl && !drawer.contains(previousFocusedEl)) {
			previousFocusedEl.focus?.();
		}
		previousFocusedEl = null;
	}

	function syncSecondaryMenuBg(el) {
		if (!secondaryDrawer || !el) return;
		const bg = el.dataset.secondaryMenuBg || 'white';
		secondaryDrawer.classList.toggle('menu-drawer__secondary--bg-grey', bg === 'grey');
	}

	function disarmSecondaryTapShield() {
		if (secondaryTapShieldTimer) {
			clearTimeout(secondaryTapShieldTimer);
			secondaryTapShieldTimer = null;
		}
		const shield = secondaryDrawer?.querySelector('.menu-drawer__secondary-tap-shield');
		if (shield) shield.classList.remove('is-active');
	}

	/** @param {boolean} [instant=true] Tab/hover: skip motion. Mega dismiss: animated path handles is-open separately. */
	function hideSecondaryDrawer(instant = true) {
		disarmSecondaryTapShield();
		if (!secondaryDrawer) return;
		if (instant) {
			secondaryDrawer.classList.add('menu-drawer__secondary--instant');
			secondaryDrawer.classList.remove('is-open', 'menu-drawer__secondary--promo-grid');
			requestAnimationFrame(() => {
				secondaryDrawer.classList.remove('menu-drawer__secondary--instant');
			});
		} else {
			secondaryDrawer.classList.remove('is-open');
		}
	}

	function activateTab(blockIndex) {
		tabs.forEach((t) => {
			t.classList.remove('is-active');
			t.setAttribute('aria-selected', 'false');
		});
		panels.forEach((p) => p.classList.remove('is-active'));

		const tab = drawer.querySelector(`.menu-drawer__tab[data-tab-index="${blockIndex}"]`);
		const panel = document.getElementById(`menu-panel-${blockIndex}`);
		if (tab) {
			tab.classList.add('is-active');
			tab.setAttribute('aria-selected', 'true');
		}
		panel?.classList.add('is-active');
		syncSecondaryMenuBg(panel);
		hideSecondaryDrawer(true);
	}

	function showDrawer() {
		if (closeDrawerTransitionHandler) {
			drawer.removeEventListener('transitionend', closeDrawerTransitionHandler);
			closeDrawerTransitionHandler = null;
		}
		isClosingDrawer = false;
		drawer.style.removeProperty('transform');
		drawer.style.removeProperty('transition');
		setDrawerTop();
		drawer.classList.add('is-open');
		lockScroll();
		syncMobileMenuButton();
	}

	function startPrimaryClose() {
		const onEnd = (e) => {
			if (e.target !== drawer || e.propertyName !== 'transform') return;
			drawer.removeEventListener('transitionend', onEnd);
			closeDrawerTransitionHandler = null;
			drawer.classList.remove('menu-drawer--closing');
			if (secondaryDrawer) {
				secondaryDrawer.classList.remove('menu-drawer__secondary--promo-grid');
				hideSecondaryDrawer(true);
			}
			/* Suppress the transition before clearing the inline transform, otherwise the browser
			 * starts a new transition from the combined-close position back toward the viewport.
			 * RAF defers the restore so the instant change is committed before transitions re-enable. */
			drawer.style.setProperty('transition', 'none');
			drawer.style.removeProperty('transform');
			requestAnimationFrame(() => drawer.style.removeProperty('transition'));
			unlockScroll();
			isClosingDrawer = false;
			syncMobileMenuButton();
		};
		closeDrawerTransitionHandler = onEnd;
		drawer.addEventListener('transitionend', onEnd);
		drawer.classList.add('menu-drawer--closing');
		if (backdrop) {
			if (closeDuration) backdrop.style.setProperty('transition-duration', closeDuration);
			backdrop.style.setProperty('opacity', '0');
		}
		drawer.classList.remove('is-open');
	}

	function closeDrawer() {
		if (!drawer.classList.contains('is-open') || isClosingDrawer) return;

		/* Mobile uses no CSS transition — transitionend never fires; use instant close path. */
		if (mqReducedMotion.matches || mqMobile.matches) {
			if (closeDrawerTransitionHandler) {
				drawer.removeEventListener('transitionend', closeDrawerTransitionHandler);
				closeDrawerTransitionHandler = null;
			}
			hideSecondaryDrawer(true);
			drawer.classList.remove('is-open');
			unlockScroll();
			syncMobileMenuButton();
			return;
		}

		isClosingDrawer = true;

		if (secondaryDrawer && secondaryDrawer.classList.contains('is-open')) {
			/* Secondary is visible — translate far enough left that both panels leave the viewport together. */
			drawer.style.setProperty('transform', `translate3d(calc(-100% - ${secondaryDrawer.offsetWidth}px), 0, 0)`);
		}

		startPrimaryClose();
	}

	function openNavItem(item) {
		const blockIndex = item.dataset.blockIndex;
		if (!blockIndex || !drawer.querySelector(`.menu-drawer__tab[data-tab-index="${blockIndex}"]`)) return;
		activateTab(blockIndex);
		showDrawer();
	}

	setDrawerTop();
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(setDrawerTop, 50);
	});
	if (announcement) {
		new ResizeObserver(setDrawerTop).observe(announcement);
	}

	(function initCtaTileVideoHover() {
		drawer.querySelectorAll('.menu-drawer__cta-tile-card__media-asset--video').forEach((el) => {
			if (!(el instanceof HTMLVideoElement)) return;
			el.controls = false;
			const container = el.closest('.menu-drawer__cta-tile-card__container');
			if (!container) return;
			const play = () => {
				if (mqReducedMotion.matches) return;
				el.play().catch(() => {});
			};
			const pause = () => {
				el.pause();
				try {
					el.currentTime = 0;
				} catch (_) {}
			};
			container.addEventListener('mouseenter', play);
			container.addEventListener('mouseleave', pause);
			container.addEventListener('focusin', play);
			container.addEventListener('focusout', pause);
		});
	})();

	navItems.forEach((item) => {
		item.addEventListener('mouseenter', () => openNavItem(item));
		item.addEventListener('focusin', () => openNavItem(item));
	});

	tabs.forEach((tab) => {
		const tabIndex = tab.dataset.tabIndex;
		tab.addEventListener('mouseenter', () => activateTab(tabIndex));
		tab.addEventListener('click', (e) => {
			if (!mqMobile.matches) return;
			e.preventDefault();
			activateTab(tabIndex);
		});
	});

	if (mobileMenuBtn) {
		mobileMenuBtn.addEventListener('click', (e) => {
			e.preventDefault();
			if (!mqMobile.matches) return;
			if (drawer.classList.contains('is-open')) {
				closeDrawer();
			} else {
				const idx = tabs[0]?.dataset.tabIndex ?? '1';
				activateTab(idx);
				showDrawer();
			}
		});
	}

	if (typeof mqMobile.addEventListener === 'function') {
		mqMobile.addEventListener('change', syncMobileMenuButton);
	} else if (typeof mqMobile.addListener === 'function') {
		mqMobile.addListener(syncMobileMenuButton);
	}

	document.addEventListener(
		'click',
		(e) => {
			if (!drawer.classList.contains('is-open') || isClosingDrawer) return;
			if (e.target?.closest?.('.header-menus')) return;
			closeDrawer();
		},
		true
	);

	function openSecondaryForLi(li) {
		if (!secondaryDrawer) return;
		const panelId = li.getAttribute('data-secondary-target') || li.dataset.secondaryTarget;
		if (!panelId) return;
		const wasOpen = secondaryDrawer.classList.contains('is-open');
		secondaryDrawer.querySelectorAll('.menu-drawer__secondary-panel').forEach((p) => p.classList.remove('is-active'));
		const panelEl = document.getElementById(panelId);
		if (!wasOpen) secondaryDrawer.classList.add('menu-drawer__secondary--instant');
		if (panelEl) {
			panelEl.classList.add('is-active');
			syncSecondaryMenuBg(panelEl);
			secondaryDrawer.classList.toggle(
				'menu-drawer__secondary--promo-grid',
				panelEl.classList.contains('menu-drawer__secondary-panel--promo-grid')
			);
		}
		if (!wasOpen) {
			void secondaryDrawer.offsetWidth;
			secondaryDrawer.classList.remove('menu-drawer__secondary--instant');
		}
		secondaryDrawer.classList.add('is-open');

		/* iOS/WebKit: the tap that opened the column can synthesize a second hit on whatever
		 * appears under the finger (often the first promo tile). Brief shield absorbs it. */
		if (mqMobile.matches) {
			let shield = secondaryDrawer.querySelector('.menu-drawer__secondary-tap-shield');
			if (!shield) {
				shield = document.createElement('div');
				shield.className = 'menu-drawer__secondary-tap-shield';
				shield.setAttribute('aria-hidden', 'true');
				secondaryDrawer.appendChild(shield);
			}
			shield.classList.add('is-active');
			if (secondaryTapShieldTimer) clearTimeout(secondaryTapShieldTimer);
			secondaryTapShieldTimer = setTimeout(() => {
				shield.classList.remove('is-active');
				secondaryTapShieldTimer = null;
			}, 420);
		}
	}

	/*
	 * Mobile: block navigation on primary rows that open a secondary panel.
	 * Must not live inside `if (secondaryDrawer)` — if that query failed, the handler was never registered.
	 * Use li[data-secondary-target] (scoped to tab panels) so we always match and run in capture phase.
	 */
	drawer.addEventListener(
		'click',
		(e) => {
			if (!mqMobile.matches) return;
			const li = e.target.closest('.menu-drawer__panels li[data-secondary-target]');
			if (!li) return;
			e.preventDefault();
			e.stopImmediatePropagation();
			openSecondaryForLi(li);
		},
		true
	);

	if (secondaryDrawer) {
		secondaryDrawer.addEventListener('click', (e) => {
			if (!mqMobile.matches) return;
			const back = e.target.closest(
				'.menu-drawer__secondary-breadcrumb__chev, .menu-drawer__secondary-breadcrumb__current'
			);
			if (!back || !secondaryDrawer.contains(back)) return;
			e.preventDefault();
			hideSecondaryDrawer(true);
		});

		drawer.querySelectorAll('.menu-drawer__links li[data-has-children]').forEach((li) => {
			li.addEventListener('mouseenter', () => openSecondaryForLi(li));
			li.addEventListener('focusin', (e) => {
				if (li.contains(e.target)) openSecondaryForLi(li);
			});
		});

		drawer.querySelectorAll('.menu-drawer__links li:not([data-has-children])').forEach((item) => {
			item.addEventListener('mouseenter', () => hideSecondaryDrawer(false));
		});

		drawer.querySelectorAll('.menu-drawer__section--products, .menu-drawer__shop-all').forEach((el) => {
			el.addEventListener('mouseenter', () => hideSecondaryDrawer(false));
			el.addEventListener('click', () => {
				if (mqMobile.matches) hideSecondaryDrawer(true);
			});
		});
	}

	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape' || !drawer.classList.contains('is-open') || isClosingDrawer) return;
		closeDrawer();
	});
})();
